export default "__VITE_ASSET__DeH9rX2d__"